"use client"; // Error boundaries must be Client Components

import { useEffect } from "react";
import ErrorComponent from "@/components/empty/ErrorComponent";
import logger from "@/utils/logger";
import styles from "./styles.module.scss";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logger.error(error);
  }, [error]);

  return (
    <div className={styles.container}>
      <ErrorComponent
        headline="Aaand... no good!"
        subtext="We ran into an error on our end. Please try again later."
      />
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      />
    </div>
  );
}
